import type { QuestionRendererRegistry } from './types';
import { ShortTextQuestion } from './questions/ShortTextQuestion';
import { LongTextQuestion } from './questions/LongTextQuestion';
import { RichTextQuestion } from './questions/RichTextQuestion';
import { ImageQuestion } from './questions/ImageQuestion';
import { DividerQuestion } from './questions/DividerQuestion';
import { CalloutQuestion } from './questions/CalloutQuestion';
import { ReadOnlyTextQuestion } from './questions/ReadOnlyTextQuestion';
import { LinkQuestion } from './questions/LinkQuestion';
import { MultipleChoiceSingleQuestion } from './questions/MultipleChoiceSingleQuestion';
import { MultipleChoiceMultiQuestion } from './questions/MultipleChoiceMultiQuestion';
import { FileUploadQuestion } from './questions/FileUploadQuestion';
import { SignatureQuestion } from './questions/SignatureQuestion';
import { TableQuestion } from './questions/TableQuestion';
import { EmailQuestion } from './questions/EmailQuestion';
import { PhoneNumberQuestion } from './questions/PhoneNumberQuestion';
import { DateQuestion } from './questions/DateQuestion';
import { TimeQuestion } from './questions/TimeQuestion';

export const QUESTION_RENDERERS: QuestionRendererRegistry = {
  short_text: ShortTextQuestion,
  long_text: LongTextQuestion,
  rich_text: RichTextQuestion,
  image: ImageQuestion,
  divider: DividerQuestion,
  callout: CalloutQuestion,
  read_only_text: ReadOnlyTextQuestion,
  link: LinkQuestion,
  multiple_choice_single: MultipleChoiceSingleQuestion,
  multiple_choice_multi: MultipleChoiceMultiQuestion,
  file_upload: FileUploadQuestion,
  signature: SignatureQuestion,
  table: TableQuestion,
  email: EmailQuestion,
  phone_number: PhoneNumberQuestion,
  date: DateQuestion,
  time: TimeQuestion,
};
